import { jsx as r, jsxs as p } from "react/jsx-runtime";
import { useState as T, useRef as ee, useCallback as te, useEffect as ne } from "react";
import { styled as F, useTheme as Ve } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as Re } from "./useQuantum-50e8fd44.mjs";
import { b as Ae } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import { b as oe } from "./useSlots-a1aa6a84.mjs";
import { D as E } from "./index-2be68378.mjs";
import { Icon as C } from "./icon.js";
import { I as R } from "./helperText-d9646f54.mjs";
import { TextInput as Oe } from "./textInput.js";
import { u as ce } from "./uniqueId-321287e8.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./closeButton.js";
import "./iconButton.js";
import "@fcamna/shared-icons";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./menu.js";
import "./radio.js";
const Se = "timePickerInput", We = F.div`
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.display;
}};
  width: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.width;
}};
  padding: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.padding;
}};
  flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.flexDirection;
}};
  align-items: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.alignItems;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.gap;
}};
  && div[aria-disabled='true'] {
    filter: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.filter;
}};
    opacity: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.opacity;
}};
    pointer-events: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.pointerEvents;
}};
  }
  & input[disabled]::placeholder {
    color: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.Wrapper.input.disabledPlaceholder.color;
}};
  }
`, xe = F.span`
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.display;
}};
  height: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.height;
}};
  width: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.width;
}};
  justify-content: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.justifyContent;
}};
  align-items: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.alignItems;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.gap;
}};
  color: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.color;
}};
  background-color: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.backgroundColor;
}};
  border: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.border;
}};
  cursor: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.cursor;
}};
  border-radius: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.borderRadius;
}};
  &:disabled {
    cursor: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.disabled.cursor;
}};
  }
  svg {
    height: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.svg.height;
}} !important;
    width: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.ClearButton.svg.width;
}} !important;
  }
`, De = F.span`
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.IconWrapper.display;
}};
  align-items: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.IconWrapper.alignItems;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.IconWrapper.gap;
}};
  ${(e) => {
  var t;
  if (e.$hasClearIcon)
    return `margin-left: -${(t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.timePickerInput.IconWrapper.marginLeft}`;
}}
`;
function Me(e, t) {
  let u = -1;
  if (t === "12") {
    for (let s = 0; s < e.length; s++)
      if (/^[amp]$/i.test(e[s])) {
        u = s;
        break;
      }
  }
  const A = u > 0 ? e.substring(0, u) : e, O = u > 0 ? e.substring(u) : "";
  return [A, O];
}
const ae = ({
  placeholder: e = "Select time...",
  label: t,
  showRequiredIndicator: u,
  optionalText: A,
  infoText: O,
  infoType: s = "tooltip",
  popupTipHeader: ie = "Info",
  size: le = "medium",
  value: c = { inputValue: "", selectedValue: "" },
  format: k = "12",
  isDisabled: l = !1,
  isInvalid: b = !1,
  helperText: S,
  stepInterval: U = 60,
  minTime: N = "12:00 AM",
  maxTime: H = "11:00 PM",
  options: d,
  hasClearIcon: K = !1,
  isRequired: L = !1,
  required: W = L,
  onChange: w,
  onBlur: x,
  labelProp: B = {
    label: t,
    showRequiredIndicator: u
  },
  infoProp: re = {
    infoText: O,
    infoType: s,
    popupTipHeader: ie
  },
  trailingText: ue = A,
  noResultText: me,
  helperTextProp: j = {
    ...!b && S && { defaultProp: { helperText: S } },
    ...b && {
      secondaryProp: { helperText: S }
    }
  },
  inputState: se = ((ke) => (ke = j.secondaryProp) == null ? void 0 : ke.state)(),
  exceedOverflow: de = !1,
  menuDirection: Ie = "down_auto",
  children: he
}) => {
  var Y, Z, v;
  const fe = Re({ label: "Time Picker Input" }), [f, _] = T([]), [V, P] = T([]), [$, q] = T(!1), D = ee(ce(Se)), z = ee(null), Pe = {
    inputValue: "",
    selectedValue: ""
  }, M = se || (b ? R.ERROR : R.NONE), $e = Ae("combobox", {
    ariaExpanded: $,
    ariaDisabled: l,
    ariaRequired: L || (B == null ? void 0 : B.showRequiredIndicator) || W,
    ariaInvalid: R.ERROR === M || R.CAUTION === M,
    ariaHaspopup: "listbox",
    ariaControls: `list-${D.current}`
  }), I = Ve(), Q = te((n, o, a, i) => {
    const m = [], h = /* @__PURE__ */ new Date(`01/01/2000 ${o}`), g = /* @__PURE__ */ new Date(`01/01/2000 ${a}`), y = new Date(h.getTime());
    for (; y.getTime() <= g.getTime(); ) {
      const Be = {
        label: J(y, i),
        value: J(y, i)
      };
      m.push(Be), y.setMinutes(y.getMinutes() + n);
    }
    _(m), P(m);
  }, []), X = te(
    (n) => {
      if (n) {
        const [o, a] = Me(n, k), i = o.replace(/[\s:]/g, "");
        return f.filter((h) => {
          const g = h.label.toLowerCase().replace(/[\s:]/g, "");
          return g.includes(`${i}`) && g.includes(a.toLowerCase());
        });
      }
    },
    [k, f]
  );
  ne(() => {
    d != null && d.length ? (_(d), P(d)) : Q(U, N, H, k);
  }, [U, N, H, k, d, Q]), ne(() => {
    var o;
    const n = X((o = c.inputValue) == null ? void 0 : o.toLowerCase());
    c.inputValue ? P(n || []) : P(f);
  }, [X, c.inputValue, f]);
  const G = (n) => {
    var o;
    n.stopPropagation(), w(Pe), P(f), (o = z.current) == null || o.focus();
  }, ge = (n) => {
    const o = n.key.toUpperCase();
    if (/\d/.test(o) || o === ":" || o === " " || k === "12" && (o === "A" || o === "P" || o === "M") || n.key !== "Backspace" && n.key !== "Delete" && n.key !== "ArrowLeft" && n.key !== "ArrowRight" && n.key !== "ArrowUp" && n.key !== "ArrowDown" && n.key !== "Tab" && !(n.metaKey && n.key === "a") && // Command + A on Mac
    !(n.ctrlKey && n.key === "a") && n.preventDefault(), n.key === "Enter" && $) {
      const i = V[0];
      w({
        inputValue: i.label,
        selectedValue: i.label
      });
    }
  }, J = (n, o) => {
    const a = n.getHours(), i = n.getMinutes(), m = i < 10 ? "0" + i : i;
    if (o === "12") {
      const h = a >= 12 ? "PM" : "AM";
      return `${a % 12 || 12}:${m} ${h}`;
    } else
      return `${a < 10 ? `0${a}` : a}:${m}`;
  }, ye = (n) => {
    n.currentTarget.contains(n.relatedTarget) || x == null || x(n);
  }, Ce = oe(
    he,
    {
      clearButton: ae.ClearIcon
    },
    oe.PickType.LAST
  ), be = /* @__PURE__ */ r(
    xe,
    {
      "aria-label": "clear",
      tabIndex: 0,
      role: "button",
      ...(Y = Ce.clearButton) == null ? void 0 : Y.props,
      onClick: G,
      onKeyUp: (n) => {
        (n.key === "Enter" || n.key === " ") && (n.preventDefault(), n.stopPropagation(), G(n));
      },
      disabled: l,
      children: /* @__PURE__ */ r(C, { name: "cancelCloseFilled" })
    }
  ), we = V == null ? void 0 : V.map(({ label: n, value: o, disabled: a }) => /* @__PURE__ */ r(
    E.Item,
    {
      label: n,
      value: o || n,
      disabled: !!a,
      isSelected: c.selectedValue === o
    },
    `${o}_${ce(o)}`
  ));
  return /* @__PURE__ */ r(
    We,
    {
      onBlur: ye,
      ...fe,
      children: /* @__PURE__ */ p(
        E,
        {
          className: "no-filter",
          menuOpen: !l && $,
          onChange: (n, o) => {
            w({
              inputValue: o.label,
              selectedValue: o.label
            });
          },
          closeOnSelect: !0,
          handleMenuOpen: (n) => q(n),
          isDisabled: l,
          uniqueIdentifier: D.current,
          exceedOverflow: de,
          noResultText: me || "No results found",
          menuDirection: Ie,
          children: [
            /* @__PURE__ */ r(E.Control, { children: /* @__PURE__ */ r(
              Oe,
              {
                id: `control-${D.current}`,
                placeholder: e,
                value: c != null && c.inputValue ? c == null ? void 0 : c.inputValue : "",
                onChange: (n) => {
                  n.target.value = n.target.value.toUpperCase().slice(0, 8), w({
                    inputValue: n.target.value,
                    selectedValue: `${c.selectedValue}`
                  }), q(!0);
                },
                onKeyDown: ge,
                startAdornment: /* @__PURE__ */ r(
                  C,
                  {
                    name: "clock",
                    style: {
                      color: `${l ? I.components.timePickerInput.InlineStyles.icons.disableColor.clockIcon : I.components.timePickerInput.InlineStyles.icons.defaultColor.clockIcon}`
                    }
                  }
                ),
                endAdornment: /* @__PURE__ */ p(
                  De,
                  {
                    $hasClearIcon: !!((c != null && c.selectedValue && ((Z = c.selectedValue) == null ? void 0 : Z.length) > 0 || c != null && c.inputValue && ((v = c.inputValue) == null ? void 0 : v.length) > 0) && K),
                    $isDisabled: l,
                    children: [
                      (!!(c != null && c.selectedValue) || !!(c != null && c.inputValue)) && K && be,
                      $ ? /* @__PURE__ */ r(
                        C,
                        {
                          name: "caretUp",
                          style: {
                            color: `${l ? I.components.timePickerInput.InlineStyles.icons.disableColor.caretUp : I.components.timePickerInput.InlineStyles.icons.defaultColor.caretUp}`,
                            pointerEvents: "none"
                          }
                        }
                      ) : /* @__PURE__ */ r(
                        C,
                        {
                          name: "caretDown",
                          style: {
                            color: `${l ? I.components.timePickerInput.InlineStyles.icons.disableColor.caretDown : I.components.timePickerInput.InlineStyles.icons.defaultColor.caretDown}`,
                            pointerEvents: "none"
                          }
                        }
                      )
                    ]
                  }
                ),
                onKeyUp: (n) => {
                  n.key === " " && n.stopPropagation();
                },
                textSize: le,
                disabled: l,
                isInvalid: b,
                showErrorIcon: !1,
                required: W,
                labelProp: {
                  showRequiredIndicator: W,
                  ...B
                },
                infoProp: { ...re },
                trailingText: ue,
                helperTextProp: $ ? void 0 : j,
                inputState: M,
                ...$e,
                role: "combobox",
                inputRef: z
              }
            ) }),
            we
          ]
        }
      )
    }
  );
};
ae.ClearIcon = C;
export {
  ae as TimePickerInput
};
